module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-SemiBold-54b6be6a7edc5b3cbdd615e2c9a54b8b.woff2";